import { IDeleteUsuarioUseCase } from "../../../presentation/useCases/delete/delete_usuario_use_case";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * DeleteUsuarioUseCase
 */

export class DeleteUsuarioUseCase implements IDeleteUsuarioUseCase {
  constructor(private readonly repository: IAdministracaoRepository) { }

  async execute(idUsuario: number): Promise<void> {
    await this.repository.deleteUsuario(idUsuario);

  }
}
